import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { UserRole } from '@fsp/types';

interface PermissionsRouteProps {
  children?: React.ReactNode;
  requireOrganisation?: boolean;
  roles?: UserRole[];
}

export const PermissionsRoute: React.FC<PermissionsRouteProps> = ({
  children,
  requireOrganisation = true,
  roles = [UserRole.fsp, UserRole.ADMIN, UserRole.MEMBER, UserRole.OWNER, UserRole.VIEWER, UserRole.AUDITOR, UserRole.APPROVER],
}) => {
  const { loading, currentOrganisation, organisations } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!roles.includes(currentOrganisation?.role || UserRole.VIEWER)) {
    return <Navigate to="/403" replace />;
  }

  if (requireOrganisation && organisations.length === 0) {
    return <Navigate to="/select-organisation" replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default PermissionsRoute;
